import React from 'react';

import {
  Typography,
  ConfirmDialog as UIConfirmDialogV2,
} from '@gogame/components';

import {
  ACTIVE,
  DELETED,
  PAUSED,
} from 'scenes/Trackers/Tracker/components/TrackerDataTable/components/CreativeStatus/constants';

const actionsMap = {
  [ACTIVE]: 'Start',
  [DELETED]: 'Delete',
  [PAUSED]: 'Pause',
};

const statusMap = {
  [ACTIVE]: 'Active',
  [DELETED]: 'Deleted',
  [PAUSED]: 'Paused',
};

const ChangeStatusDialog = ({
  onSubmit,
  onClose,
  open,
  onExited,
  status,
  dimensionName,
}) => {
  const actionName = actionsMap[status];
  return (
    <UIConfirmDialogV2
      title={`${actionName} selected ${dimensionName} ?`}
      confirmActionLabel={actionName}
      onSubmit={onSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    >
      <Typography>
        Status of the selected {dimensionName}s will be changed to{' '}
        {statusMap[status]}
      </Typography>
    </UIConfirmDialogV2>
  );
};

export default ChangeStatusDialog;
